
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_a5824_13",
  "arrow-outer": "awsui_arrow-outer_xjuzf_a5824_17",
  "arrow-inner": "awsui_arrow-inner_xjuzf_a5824_17",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_a5824_59",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_a5824_59",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_a5824_62",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_a5824_62",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_a5824_65",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_a5824_65",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_a5824_65",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_a5824_65",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_a5824_68",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_a5824_68",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_a5824_68",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_a5824_68",
  "arrow-variant-info": "awsui_arrow-variant-info_xjuzf_a5824_72",
  "body": "awsui_body_xjuzf_a5824_83",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_a5824_120",
  "body-variant-chart": "awsui_body-variant-chart_xjuzf_a5824_123",
  "has-dismiss": "awsui_has-dismiss_xjuzf_a5824_128",
  "dismiss": "awsui_dismiss_xjuzf_a5824_133",
  "dismiss-control": "awsui_dismiss-control_xjuzf_a5824_141",
  "header-row": "awsui_header-row_xjuzf_a5824_145",
  "header": "awsui_header_xjuzf_a5824_145",
  "content": "awsui_content_xjuzf_a5824_174",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_a5824_183",
  "container": "awsui_container_xjuzf_a5824_191",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_a5824_206",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_a5824_206",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_a5824_206",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_a5824_211",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_a5824_211",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_a5824_211",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_a5824_216",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_a5824_216",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_a5824_221",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_a5824_221",
  "container-body": "awsui_container-body_xjuzf_a5824_227",
  "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_a5824_267",
  "container-body-size-small": "awsui_container-body-size-small_xjuzf_a5824_272",
  "fixed-width": "awsui_fixed-width_xjuzf_a5824_275",
  "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_a5824_279",
  "container-body-size-large": "awsui_container-body-size-large_xjuzf_a5824_286",
  "container-arrow": "awsui_container-arrow_xjuzf_a5824_206",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_a5824_336",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_a5824_1",
  "refresh": "awsui_refresh_xjuzf_a5824_390",
  "awsui-popover-settle-down": "awsui_awsui-popover-settle-down_xjuzf_a5824_1",
  "awsui-popover-settle-up": "awsui_awsui-popover-settle-up_xjuzf_a5824_1",
  "awsui-popover-settle-end": "awsui_awsui-popover-settle-end_xjuzf_a5824_1",
  "awsui-popover-settle-start": "awsui_awsui-popover-settle-start_xjuzf_a5824_1",
  "root": "awsui_root_xjuzf_a5824_521",
  "no-wrap": "awsui_no-wrap_xjuzf_a5824_553",
  "trigger-type-text-inline": "awsui_trigger-type-text-inline_xjuzf_a5824_556",
  "overflow-ellipsis": "awsui_overflow-ellipsis_xjuzf_a5824_556",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_a5824_556",
  "root-filtering-token": "awsui_root-filtering-token_xjuzf_a5824_578",
  "trigger": "awsui_trigger_xjuzf_a5824_556",
  "in-inline-token": "awsui_in-inline-token_xjuzf_a5824_620",
  "trigger-type-filtering-token": "awsui_trigger-type-filtering-token_xjuzf_a5824_668",
  "popover-inline-content": "awsui_popover-inline-content_xjuzf_a5824_672",
  "hover-area": "awsui_hover-area_xjuzf_a5824_676"
};
  